<template>
    <q-table
        ref="table"
        :data="completed"
        :columns="columns_completed"
        row-key="id"
        :filter="filter"
        :pagination.sync="server_pagination"
        @request="requestCompleted"
        :loading="loading"
        :no-data-label="$t('no_data_avaliable')"
        :no-results-label="$t('no_results_found')"
        :loading-label="$t('loading_data')"
        :rows-per-page-label="$t('items_per_page')"
        :rows-per-page-options="[5,10,50,100]"
        binary-state-sort
        class="q-mt-lg"
        >


        <template slot="top" slot-scope="props" :props="props">
            <q-search v-model="filter" icon="fas fa-search" :placeholder="$t('search')" :debounce="500" />

            <div class="col" />
            <q-btn color="secondary" icon="fas fa-download" :label="$t('completion_report')" @click="downloadCertificate()" />
        </template>

        <q-tr slot="header" slot-scope="props" :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
            </q-th>
        </q-tr>

        <template slot="body" slot-scope="props">
            <q-tr :props="props">
                <q-td key="full_name" :props="props">
                    {{ props.row.full_name }}
                </q-td>

                <q-td key="email" :props="props">
                    {{ props.row.email }}
                </q-td>

                <q-td key="progress" :props="props">
                    {{ `${(props.row.progress).toFixed(1)}%` }}
                </q-td>

                <q-td key="status" :props="props" auto-width>
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width text-center">
                        {{ $t(getTextStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

            </q-tr>
        </template>
    </q-table>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    props: ['load', 'id'],

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            completed: [],
            filter: '',
            columns_completed: [
                {
                    name: 'full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'full_name',
                    sortable: true,
                },
                {
                    name: 'email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'email',
                    sortable: true,
                },
                {
                    name: 'progress',
                    required: true,
                    label: 'progress',
                    align: 'center',
                    field: 'progress',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'center',
                    field: 'status',
                    sortable: true,
                },
            ],
            loading: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        requestCompleted({ pagination }) {
            this.completed = []
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by,
                "search": this.filter
            }

            this.savePagination()

            if (this.id) {
                this.$axios.get(`/admin_podcast/podcasts/${this.id}/podcast_user_completed/?${this.$qs.stringify(data)}`, this.getHeader)
                .then(response => {
                    this.server_pagination.rowsNumber = response.data.count

                    response.data.results.map((e) => {
                        this.completed.push(e)
                    })

                    this.loading = false
                })
                .catch(e => {
                    this.loading = false
                    console.log(e)
                })
            }
        },

        getTextStatus(status) {
            if (status === 1) return 'completed'
            else return 'not_completed'
        },

        getColorStatus(status) {
            if (status === 1) return 'positive'
            else return 'warning'
        },

        getIconStatus(status) {
            if (status === 1) return 'fas fa-check'
            else return 'fas fa-times'
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        },

        downloadCertificate() {
            let message = this.$t('generating_import_file_message')
            this.$q.loading.show({
                message
            })
            this.$axios.get(`admin_podcast/podcasts/${this.id}/podcast_user_completed/generate_report/`, this.getHeader)
            .then(response => {
                this.forceFileDownload(response.data.path_url)
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
            .finally(() =>{
                this.$q.loading.hide()
            })
        },

        forceFileDownload(response){
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
        },
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestCompleted({ pagination: this.server_pagination })
            }
        },

        num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    mounted() {
        this.loadPagination()
        this.requestCompleted({ pagination: this.server_pagination })
    }
}
</script>

<style>

</style>
